/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="66.15"
        height="95.58"
        viewBox="0 0 66.15 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M8.27 88.13c0-13.67 11.13-22.89 24.8-22.89s24.8 9.22 24.8 22.89M52 39.59a93.26 93.26 0 0 0-18.93-1.79 94.12 94.12 0 0 0-18.87 1.79 25.29 25.29 0 0 0 35.71 2 24.54 24.54 0 0 0 2-2Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M64.9 0H1.25A1.25 1.25 0 0 0 0 1.25v6.2A1.25 1.25 0 0 0 1.25 8.7H64.9a1.25 1.25 0 0 0 1.25-1.25v-6.2A1.25 1.25 0 0 0 64.9 0Zm-1.25 2.5v3.7H2.5V2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M8.27 6.2a1.26 1.26 0 0 1 1.25 1.12v16.51a22.94 22.94 0 0 0 20 22.72 1.25 1.25 0 0 1-.28 2.45A25.43 25.43 0 0 1 7 24.22V7.45A1.24 1.24 0 0 1 8.23 6.2ZM57.87 6.7a1.26 1.26 0 0 1 1.25 1.12v16A25.42 25.42 0 0 1 36.9 49a1.25 1.25 0 0 1-.31-2.48 22.92 22.92 0 0 0 20-22.35V8a1.25 1.25 0 0 1 1.2-1.3ZM64.9 86.88H1.25A1.25 1.25 0 0 0 0 88.13v6.2a1.25 1.25 0 0 0 1.25 1.25H64.9a1.25 1.25 0 0 0 1.25-1.25v-6.2a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v3.7H2.5v-3.7Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M29.24 46.55a1.26 1.26 0 0 1 1.4 1.09A1.24 1.24 0 0 1 29.56 49a22.92 22.92 0 0 0-20 22.35V88.1a1.25 1.25 0 0 1-2.49.13V71.75a25.44 25.44 0 0 1 22.17-25.2ZM36.9 46.55a25.44 25.44 0 0 1 22.22 24.82v16.76a1.25 1.25 0 0 1-2.49.13V71.75A22.94 22.94 0 0 0 36.59 49a1.25 1.25 0 0 1 .19-2.49Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M34.48 50.85a1.41 1.41 0 1 1-1.41-1.41 1.41 1.41 0 0 1 1.41 1.41M34.48 55.9a1.41 1.41 0 1 1-1.41-1.41 1.41 1.41 0 0 1 1.41 1.41M34.48 61a1.41 1.41 0 1 1-1.41-1.41A1.41 1.41 0 0 1 34.48 61"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'HourglassIcon';

export default Icon;
